var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pos_settings" },
    [
      _vm._l(_vm.basic_params, function (key_val, key_name) {
        return key_name.length > 0 && _vm.is_text_field(key_name)
          ? _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("info_field", {
                  attrs: {
                    f_uniq: key_name,
                    f_type: key_name,
                    f_title: _vm.__t(key_name.toUpperCase()),
                    is_disabled: false,
                    f_val: _vm.basic_params[key_name],
                  },
                  on: {
                    change: function ($event) {
                      return _vm.on_change_value(key_name)
                    },
                  },
                  model: {
                    value: _vm.basic_params[key_name],
                    callback: function ($$v) {
                      _vm.$set(_vm.basic_params, key_name, $$v)
                    },
                    expression: "basic_params[key_name]",
                  },
                }),
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.basic_params, function (key_val, key_name) {
        return key_name.length > 0 && _vm.is_list_field(key_name)
          ? _c("div", { staticClass: "form-group" }, [
              key_name == "allowed_locales"
                ? _c("div", { staticClass: "form-group mt-2" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "locales_online" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.__t("LOCALES_LIST")) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.locales.length > 0
                      ? _c(
                          "div",
                          {},
                          [
                            _c("v-select", {
                              staticClass: "imc_reasons",
                              attrs: {
                                id: "locales_online",
                                reduce: function (locale) {
                                  return locale.locale_id
                                },
                                label: "market_code",
                                options: _vm.locales,
                                filterable: false,
                                multiple: true,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function (option) {
                                      return [
                                        _c("div", { staticClass: "d-center" }, [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(option.name) +
                                              "\n                            "
                                          ),
                                          _c("div", [
                                            _c("small", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(option.market_code) +
                                                  "\n                                "
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.basic_params[key_name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.basic_params, key_name, $$v)
                                },
                                expression: "basic_params[key_name]",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group row" },
        _vm._l(_vm.basic_params, function (key_val, key_name) {
          return key_name.length > 0 &&
            !_vm.is_text_field(key_name) &&
            key_name != "id"
            ? _c(
                "div",
                { staticClass: "col-lg-4 col-sm-4 col-md-4 col-xs-12 mb-3" },
                [
                  key_name == "percent_type"
                    ? _c("div", { staticClass: "form-group mt-2" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.__t("PERCENT_TYPE")) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group flex-nowrap" },
                          [
                            _c("b-form-radio-group", {
                              attrs: {
                                id: "btn-radios-1",
                                "button-variant": "outline-primary",
                                options: [
                                  {
                                    text: _vm.__t("PERCENT_LABEL"),
                                    value: "percent",
                                  },
                                  {
                                    text: _vm.__t("PERCENT_MINUS"),
                                    value: "percent_minus",
                                  },
                                  { text: _vm.__t("FIXED"), value: "fixed" },
                                ],
                                name: "radios-btn-default",
                                buttons: "",
                              },
                              on: {
                                update: function ($event) {
                                  return _vm.on_change_value(key_name)
                                },
                              },
                              model: {
                                value: _vm.basic_params[key_name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.basic_params, key_name, $$v)
                                },
                                expression: "basic_params[key_name]",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _c(
                        "div",
                        [
                          !_vm.is_list_field(key_name) &&
                          !_vm.is_text_field(key_name)
                            ? _c("yes_no", {
                                key: key_name,
                                attrs: { title: key_name },
                                on: {
                                  input: function ($event) {
                                    return _vm.on_change_value(key_name)
                                  },
                                },
                                model: {
                                  value: _vm.basic_params[key_name],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.basic_params, key_name, $$v)
                                  },
                                  expression: "basic_params[key_name]",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e()
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }